module.exports = __webpack_public_path__ + "static/media/location.0b09de3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Select/icons/location.svg
// module id = 331
// module chunks = 0